import type { CategoryItem } from '../types/api'
import { authFetch } from './apiClient'

const BASE = '/newspaper/api/v1'

export async function fetchCategories(
  citySlug: string,
  langCode: string,
  date?: string,
): Promise<CategoryItem[]> {
  const params = new URLSearchParams({
    city_slug: citySlug,
    lang_code: langCode,
  })
  if (date) params.set('date', date)
  const res = await authFetch(`${BASE}/categories/?${params}`)
  if (!res.ok) throw new Error(`categories API error: ${res.status}`)
  const data = await res.json() as { categories: CategoryItem[] }
  return data.categories
}
